import React from "react";

import { serverUrl } from "../../config";

import GridItem from "../../partials/gridItem";
import { useNavigate } from "react-router-dom";
import { parseSummary } from "../../partials/posts/postHelpers";

export default function QuizItem(props) {
  const navigate = useNavigate();

  return (
    <GridItem
      xs={props.creator ? 6 : 12}
      sm={props.creator ? 3 : 6}
      md={props.creator ? 2 : 3}
      itemClass="quiz"
      item={props.item}
      bundle={props.item?.bundle}
      id={props.item?.id}
      title={props.item?.title}
      field_body={props.creator ? "" : props.item?.summary ?? ""}
      category_label={props.item.category_labels}
      created={props.item?.created}
      hasImg={true}
      imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
      alt={`Poster for test ${props.item?.id}`}
      cardActionArea={true}
      creator={props.creator}
      cardActionCallBack={
        props.creator ? () => {} : () => navigate(`/quizzes/view/${props.item?.id}`)
      }
      contentType={props.contentType}
    ></GridItem>
  );
}
